import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "defaultOpen", "disabled", "placement", "tooltip", "use"],
  _excluded2 = ["children", "defaultOpen", "disabled", "placement", "tooltip", "use"];
import { Tooltip } from '../Tooltip/Tooltip';
import { ButtonBreeze, ButtonIconBreeze } from './ButtonBreeze';
import { jsx as _jsx } from "react/jsx-runtime";
export const ButtonBreezeTooltip = _ref => {
  let {
      children,
      defaultOpen,
      disabled,
      placement,
      tooltip,
      use
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Tooltip, {
    defaultOpen: defaultOpen,
    disabled: !disabled,
    placement: placement,
    tooltip: tooltip,
    use: use,
    children: /*#__PURE__*/_jsx(ButtonBreeze, Object.assign({}, rest, {
      disabled: disabled,
      children: children
    }))
  });
};
export const ButtonIconBreezeTooltip = _ref2 => {
  let {
      children,
      defaultOpen,
      disabled,
      placement,
      tooltip,
      use
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(Tooltip, {
    defaultOpen: defaultOpen,
    disabled: !disabled,
    placement: placement,
    tooltip: tooltip,
    use: use,
    children: /*#__PURE__*/_jsx(ButtonIconBreeze, Object.assign({}, rest, {
      disabled: disabled,
      children: children
    }))
  });
};